module.exports = __webpack_public_path__ + "media/images/icon_search_gray-430d170a420e1252cdd70dae62648c3f.png";